import React, { useState } from "react";
import styles from "./AlumniInKindGiving.module.css";
import { CornerUpRight } from "lucide-react";
import CustomiseCta from "../CustomiseCta/CustomiseCta";
import AlumniFormPopup from "../AlumniFormPopup/AlumniFormPopup";

interface ListItem {
  id: number;
  title: string;
  description: string;
}

interface InKindGivingProps {
  data: {
    title: string;
    description: string;
    cta_label: string;
    register_as_alumni?: any;
    heading_bullet_pts: {
      title: string;
      list: ListItem[];
    };
  };
}

const AlumniInKindGiving: React.FC<InKindGivingProps> = ({ data }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const openPopup = () => setIsPopupVisible(true);
  const closePopup = () => setIsPopupVisible(false);
  return (
    <div className="container">
      <AlumniFormPopup
        show={isPopupVisible}
        onHide={closePopup}
        data={data?.register_as_alumni}
      />
      <section className={styles.inKindSection}>
        <h2 className={styles.title}>{data.title}</h2>
        <p className={styles.description}>{data.description}</p>

        <h3 className={styles.subHeading}>{data.heading_bullet_pts.title}</h3>

        <ul className={styles.bulletList}>
          {data.heading_bullet_pts.list.map((item) => (
            <li key={item.id} className={styles.bulletItem}>
              <CornerUpRight className={styles.icon} />
              <div>
                <h4 className={styles.bulletTitle}>{item.title}</h4>
                <p className={styles.bulletDesc}>{item.description}</p>
              </div>
            </li>
          ))}
        </ul>

        <div className={styles.ctaSection}>
          <p className={styles.ctaLabel}>{data.cta_label}</p>

          {data?.register_as_alumni?.cta?.type === "pop-up" ? (
            <div className={styles.ctaButton}>
              <div className="d-none d-md-block">
                <button
                  style={{
                    backgroundColor:
                      data?.register_as_alumni?.cta?.button?.button_color ||
                      undefined,
                    color:
                      data?.register_as_alumni?.cta?.button?.text_color ||
                      undefined,
                  }}
                  onClick={openPopup}
                  data-interaction={
                    data?.register_as_alumni?.cta?.button?.desktop_label
                  }
                >
                  {data?.register_as_alumni?.cta?.button?.desktop_label}
                </button>
              </div>
              <div className="d-block d-md-none">
                <button
                  style={{
                    backgroundColor:
                      data?.register_as_alumni?.cta?.button?.button_color ||
                      undefined,
                    color:
                      data?.register_as_alumni?.cta?.button?.text_color ||
                      undefined,
                  }}
                  onClick={openPopup}
                  data-interaction={
                    data?.register_as_alumni?.cta?.button?.mobile_label ||
                    data?.register_as_alumni?.cta?.button?.desktop_label
                  }
                >
                  {data?.register_as_alumni?.cta?.button?.mobile_label ||
                    data?.register_as_alumni?.cta?.button?.desktop_label}
                </button>
              </div>
            </div>
          ) : (
            <div className={styles.ctaButton}>
              <CustomiseCta ctaData={data.register_as_alumni?.cta} />
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default AlumniInKindGiving;
